import { ifDefined } from 'lit/directives/if-defined.js';

export function ifNotEmpty(value: string) {
  return ifDefined(value ? value : undefined);
}
